import React, { useEffect } from "react";
import { Pagination } from "antd";
import { useState } from "react";
import {
  useGetArchiveRowCountQuery,
  useGetInfluencerPostsQuery,
  archiveInfluencerApi,
} from "../../redux/api/archiveInfluencer";
import { useSelector } from "react-redux";
import { InfluencerPostCard } from "../../components/Influencer/InfluencerPostCard";
import { Spin, Layout, Row, Col, theme } from "antd";
import { useDispatch } from "react-redux";
import { use } from "react";

const InfluencerContent = () => {
  const { token } = theme.useToken();

  const client = useSelector((state) => state.genericReporting.selectedDropdownValues['client_name']);
  const selectedUsername = useSelector(
    (state) => state.genericReporting.selectedInfluencerUsernameContains
  );
  const selectedLabels = useSelector((state) => state.genericReporting.selectedDropdownValues?.["influencer_unique_labels"] ?? []);
  const selectedPlatforms = useSelector((state) => state.genericReporting.selectedDropdownValues?.["influencer_platforms"] ?? []);
  const selectedStartDate = useSelector((state) => state.genericReporting.selectedDropdownValues['start_date']);
  const selectedEndDate = useSelector((state) => state.genericReporting.selectedDropdownValues['end_date']);

  const dispatch = useDispatch();
  const [current, setCurrent] = useState(1);
  const [pageSize, setPageSize] = useState(50);
  const [cleared, setCleared] = useState(false);

  

  const count = useGetArchiveRowCountQuery({
    client: client,
    selectedLabels: selectedLabels,
    usernameContains: selectedUsername,
    selectedPlatforms: selectedPlatforms,
    selectedDateRange: {
      'start_date': selectedStartDate,
      'end_date': selectedEndDate,
    },
  });

  const posts = useGetInfluencerPostsQuery({
    client: client,
    page: current,
    pageSize: pageSize,
    selectedLabels: selectedLabels,
    usernameContains: selectedUsername,
    selectedPlatforms: selectedPlatforms,
    selectedDateRange: {
      'start_date': selectedStartDate,
      'end_date': selectedEndDate,
    },
  });

  useEffect(() => {
    setCleared(false);
    if (
      !count.isSuccess &&
      count.isError &&
      !cleared &&
      posts.data &&
      posts.data.length > 0
    ) {
      dispatch(archiveInfluencerApi.util.resetApiState());
      setCleared(true);
    }
  }, [count, client, dispatch, cleared, posts.data, posts]);

  return (
    <Layout
      style={{
        display: "flex",
        flexDirection: "column",
        width: "100%",
        minHeight: "100%",
        alignItems: "center",
      }}
    >
      <>
        {posts.isFetching === true || posts.isLoading ? (
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              minHeight: "60vh",
              width: "100%",
              padding: "20px",
            }}
          >
            <Spin />
          </div>
        ) : posts.isError || !posts.data || posts.data.length === 0 ? (
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              minHeight: "60vh",
              width: "100%",
              padding: "20px",
            }}
          >
            <div>No posts found</div>
          </div>
        ) : (
          <Layout.Content
            style={{
              display: "flex",
              flexDirection: "row",
              flexWrap: "wrap",
              justifyContent: "center",
              alignContent: "center",
              alignItems: "center",
              marginTop: "auto",
              width: "100%",
              minHeight: "60vh",
              padding: "32px",
              marginBottom: "24px",
            }}
          >
            <Row
              gutter={[16, 42]}
              justify="center"
              wrap={true}
              style={{ width: "100%" }}
            >
              {posts.data.map((post) => {
                return (
                  <Col span={{ xs: 8, sm: 16, md: 24, lg: 32 }}>
                    <InfluencerPostCard post={post}></InfluencerPostCard>
                  </Col>
                );
              })}
            </Row>
          </Layout.Content>
        )}
      </>
      <div
        className="soft-shadow"
        style={{
          justifyContent: "center",
          alignContent: "center",
          alignItems: "center",
          display: "flex",
          marginTop: "auto",
          padding: "16px",
          backgroundColor: "var(--tertiary-color)",
          borderRadius: token.cardRadius,
        }}
      >
        <Pagination
          key={`${client}-${count.data}-${current}`}
          defaultCurrent={current}
          current={current}
          onChange={setCurrent}
          pageSize={pageSize}
          onShowSizeChange={(current, size) => setPageSize(size)}
          total={count.data}
        />
      </div>
    </Layout>
  );
};

export default InfluencerContent;
